const STATIC = {
  "/profile": ["Roots", "Account", "Profile"],

  "/review-hub": ["Roots", "Campaigns", "Review hub"],
  "/initial-approve": ["Roots", "Campaigns", "Initial approval"],
  "/for-review-campaign": ["Roots", "Campaigns", "For review"],
  "/active-campaign": ["Roots", "Campaigns", "Active"],
  "/rejected-campaign": ["Roots", "Campaigns", "Rejected"],
  "/completed-campaign": ["Roots", "Campaigns", "Completed"],
  "/paused-campaign": ["Roots", "Campaigns", "Paused"],
  "/coming-soon-campaign": ["Roots", "Campaigns", "Coming soon"],
  "/closed-campaign": ["Roots", "Campaigns", "Closed"],
  "/draft-campaign": ["Roots", "Campaigns", "Draft"],
  "/cancelled-campaign": ["Roots", "Campaigns", "Cancelled"],
  "/deleted-campaign": ["Roots", "Campaigns", "Deleted"],

  "/users": ["Roots", "People", "Users"],
  "/manage-role": ["Roots", "People", "System roles"],
  "/manage-designation": ["Roots", "People", "Designations"],
  "/commission": ["Roots", "People", "Commissions"],
  "/designation-report": ["Roots", "People", "Designation report"],
  "/manage-permissions": ["Roots", "People", "Permissions"],
  "/accredited-investors": ["Roots", "People", "Accredited investors"],

  "/investment": ["Roots", "Money", "Investments"],
  "/suitability-overview": ["Roots", "Money", "Investment payment ledger"],

  "/secondary-listings": ["Roots", "Marketplace", "Listings"],
  "/secondary-transactions": ["Roots", "Marketplace", "Transactions"],
  "/secondary-config": ["Roots", "Marketplace", "Configuration"],

  "/news": ["Roots", "Content", "News"],
  "/inventme": ["Roots", "Content", "InventMe"],

  // The /dr/* screens are the compliance queues. Every role that reaches them
  // (DR, CCO, UDP, and AD for oversight) sees the same crumbs: the screen a
  // path leads to does not change with who opened it.
  "/dr": ["Roots", "Compliance", "Reviewer overview"],
  "/dr/credentials": ["Roots", "Compliance", "My credentials"],
  "/dr/approvals": ["Roots", "Compliance", "Investor approvals"],
  "/dr/deals": ["Roots", "Compliance", "Deals review"],
  "/dr/audit": ["Roots", "Compliance", "Review audit trail"],
  "/dr/suitability": ["Roots", "Compliance", "Suitability"],
  "/compliance/decisions": ["Roots", "Compliance", "Decision review"],

  "/bdc": ["Roots", "BDC", "Overview"],
  "/bdc/network": ["Roots", "BDC", "Network"],
  "/bdc/referrals": ["Roots", "BDC", "Growth tools"],
  "/bdc/payouts": ["Roots", "BDC", "Payouts"],

  "/ad/consultant-requests": ["Roots", "Platform oversight", "Consultant approvals"],
  "/ad/commission-rates": ["Roots", "Platform oversight", "Commission rates"],
  "/ad/bdc-oversight/claims": ["Roots", "Platform oversight", "Manual claims"],
  "/ad/bdc-oversight/attribution": ["Roots", "Platform oversight", "Attribution"],
  // Compliance oversight, not platform oversight.
  "/ad/dr-oversight/credentials": ["Roots", "Compliance", "DR credentials"],
  "/ad/dr-oversight/sla-breaches": ["Roots", "Compliance", "SLA breaches"],
  "/ad/payments/pending": ["Roots", "Platform oversight", "Payments"],
  "/ad/reports/compliance": ["Roots", "Platform oversight", "Compliance"],
  "/ad/reports/audit": ["Roots", "Platform oversight", "Audit log"],
  "/ad/payouts": ["Roots", "Platform oversight", "Payouts"],
};

const PREFIX = [
  { p: "/dr/approvals/", crumbs: ["Roots", "Compliance", "Approval detail"] },
  { p: "/dr/suitability/failed/", crumbs: ["Roots", "Compliance", "Suitability outcome"] },
  { p: "/compliance/decisions/", crumbs: ["Roots", "Compliance", "Decision detail"] },
  { p: "/investment/", crumbs: ["Roots", "Money", "Investment"] },
  { p: "/transaction/", crumbs: ["Roots", "Money", "Transaction"] },
  { p: "/suitability-overview/", crumbs: ["Roots", "Money", "Investment payment"] },
  { p: "/bdc/network/", crumbs: ["Roots", "BDC", "Entity"] },
];

// `role` is the caller's workspace, not its authority: "DR" means a
// compliance session (DR, CCO or UDP), "BDC" the business-dev workspace, "AD"
// or null the admin one. It only selects the landing and fallback crumbs — the
// per-path crumbs above are the same for everyone who can reach the path.
export const breadcrumbsFor = (pathname, role) => {
  if (pathname === "/") {
    if (role === "DR") return ["Roots", "Compliance", "Dashboard"];
    if (role === "BDC") return ["Roots", "BDC", "Dashboard"];
    return ["Roots", "Admin", "Ops desk"];
  }
  if (STATIC[pathname]) return STATIC[pathname];
  for (const { p, crumbs } of PREFIX) {
    if (pathname.startsWith(p)) return crumbs;
  }
  const fallbackRoot = role === "DR" ? "Compliance" : role === "BDC" ? "BDC" : "Admin";
  return ["Roots", fallbackRoot, ""];
};

export default breadcrumbsFor;
